$(document).ready(function(){
    if($(".block__our-process-listing").length){
      function loopNext(){
        // $('.block__our-process-listing').stop().animate({scrollLeft:'+=20'}, '0.6s', 'linear', loopNext);
       }
      function stop(){
        $('.block__our-process-listing').stop();
      }

        function scrollList(classNames){
          console.log('classNames', classNames)
            const sliders = document.querySelectorAll(classNames);
            let isDown = false;
            let startX;
            let scrollLeft;
           
            
            sliders.forEach( (slider) => {
              slider.addEventListener('mousedown', (e) => {
                  isDown = true;
                  slider.classList.add('active');
                  startX = e.pageX - slider.offsetLeft;
                  scrollLeft = slider.scrollLeft;
                  console.log(slider, "slider")
              });
              slider.addEventListener('mouseleave', () => {
                                      isDown = false;
                                      slider.classList.remove('active');
              });
              slider.addEventListener('mouseup', () => {
                                      isDown = false;
                                      slider.classList.remove('active');
              });
              slider.addEventListener('mousemove', (e) => {
                  if(!isDown) return;
                  e.preventDefault();
                  const x = e.pageX - slider.offsetLeft;
                  const walk = (x - startX) * 2; //scroll-fast
                  slider.scrollLeft = scrollLeft - walk;
                  stop();
              });
             
            })
        }
        
        $('.block__our-process-listing-box').mouseover(function () {
            loopNext();
        });
        $('.block__our-process-listing-box').mouseout(function () {
          stop(); 
        });
        $('.block__our-process-listing-box').click(function () { 
          stop(); 
        });
        scrollList(".block__our-process-listing");   
    }
});

